import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Button, Checkbox, Popper, Fade, Paper } from "@mui/material";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import IosShareIcon from "@mui/icons-material/IosShare";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import mail from "../../../assets/images/ico_mail_color.png";
import kakao from "../../../assets/images/ico_kakao_color.png";
import RatingIndicator from "../../common/RatingIndicator";
import styles from "../../../assets/styles/modules/Newsinfo.module.css";
import { pasteURL } from "../../../apis/toast_message";
import {
  addScrapAPI,
  checkScrapAPI,
  deleteScrapNewsAPI,
  delScrapAPI,
} from "../../../apis/my_service";
import clip from "../../../assets/images/icon-clip-mono.png";
import defaultImg from "../../../assets/images/thumbnail_default.jpg";
import thumbnail from "../../../assets/images/thumbnail_default.jpg";
import { Obscure } from "../../common/\bobscuredImage";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const SingleNewsCard = ({ news }) => {
  const [scrap, setScrap] = useState(null); // 북마크 여부
  const [scrapIdx, setScrapIdx] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false); // 공유 모달창 오픈;
  const [subject, setSubject] = useState(""); // 이메일 제목
  const [mailBody, setMailBody] = useState(""); // 이메일 내용

  const notify = (msg, type) => {
    if (type === "success") return toast.success(msg);
    else if (type === "error") return toast.error(msg);
    else return toast(msg);
  };

  const bookmarkCheck = () => {
    checkScrapAPI(news.newsid).then((res) => {
      if (res.length > 0) {
        setScrap(true);
        setScrapIdx(res[0].scrapeidx);
      } else {
        setScrap(false);
      }
    });
  };

  const bookmarkClick = () => {
    if (scrap === true) {
      deleteScrapNewsAPI(scrapIdx).then((res) => {
        setScrap(false);
        notify("스크랩 목록에서 삭제했습니다", "success");
      });
    } else if (scrap === false) {
      addScrapAPI(news.newsid, "N").then((res) => {
        setScrap(true);
        notify("스크랩 목록에 저장했습니다", "success");
      });
    } else {
      notify("로그인이 필요합니다.", "error");
    }
  };

  useEffect(bookmarkCheck, [scrap]);
  const handleClick = () => (e) => {
    setAnchorEl(e.currentTarget);
    setOpen((prev) => !prev);
  };

  const handleClose = () => setOpen(false);

  const mailShare = () => {
    const body = `
        [뉴스썸]에서 공유한 뉴스입니다.%0D%0A
        %0D%0A
        뉴스 제목 : ${news.subject}%0D%0A
        뉴스 링크 : https://dev-www.newssalad.com${window.location.pathname}%0D%0A
        원문 링크 : ${news.url}%0D%0A
        %0D%0A
        `;
    setSubject("[뉴스썸] " + news.subject);
    setMailBody(body);
  };

  const kakaoShare = (news) => {
    window.Kakao.Share.sendCustom({
      templateId: 92864,
      templateArgs: {
        img: news.imgsrc,
        newsID: news.newsid,
        title: news.subject,
        description: news.summary,
      },
    });
  };

  return (
    <div className={styles.news_container}>
      <div className={styles.thumbnail_container}>
        <Obscure text={news?.press}>
          <img
            className={styles.thumbnail}
            src={news.imgsrc ? news.imgsrc : defaultImg}
            alt="썸네일"
            onError={(e) => {
              e.target.src = thumbnail;
            }}
          />
        </Obscure>
      </div>
      <div className={styles.news_contents}>
        <p className={styles.news_title}>{news.subject}</p>
        <p className={styles.news_summary}>
          {news.summary.length > 0 ? news.summary : "본문 내용이 없습니다"}
        </p>
        <div className={styles.news_footer} style={{ display: "flex" }}>
          <RatingIndicator
            signal={news.signal}
            percent={news.staticsentimental.percent}
          />
          <a rel="noopener noreferrer" href={news.url} target="_blank">
            <img className={styles.clip_icon} src={clip} alt="" />
            <span className={styles.news_link}>{news.url}</span>
          </a>
        </div>
        <div>
          <Checkbox
            {...label}
            className={styles.bookmark_btn}
            onClick={bookmarkClick}
            sx={{ color: "#999999" }}
            checked={scrap}
            icon={<BookmarkBorderOutlinedIcon />}
            checkedIcon={<BookmarkIcon />}
          />
          <Toaster containerStyle={{ top: 140 }} />
          <Button
            sx={{
              border: "1px solid rgba(0, 40, 100, 0.12)",
              borderRadius: "50%",
              minWidth: 0,
              color: "#999999",
              height: "44px",
              "&:focus": { border: "1px solid rgba(0, 40, 100, 0.12)" },
            }}
            className={styles.share_btn}
            onClick={handleClick("bottom-start")}
          >
            <IosShareIcon />
          </Button>
          <Popper
            open={open}
            anchorEl={anchorEl}
            placement="bottom-start"
            transition
          >
            {({ TransitionProps }) => (
              <Fade {...TransitionProps}>
                <Paper className={styles.modal}>
                  <ClearRoundedIcon
                    className={styles.close}
                    onClick={handleClose}
                  />
                  <ul className={styles.icon_container}>
                    <li>
                      <a
                        href={`mailto:?to=&Subject=${subject}&body=${mailBody}`}
                      >
                        <img src={mail} alt="kakao" onClick={mailShare} />
                      </a>
                    </li>
                    <li className={styles.icon_name}>메일</li>
                  </ul>
                  <ul className={styles.icon_container}>
                    <li>
                      <img
                        src={kakao}
                        alt="kakao"
                        onClick={() => kakaoShare(news)}
                      />
                    </li>
                    <li className={styles.icon_name}>카카오</li>
                  </ul>
                  <div className={styles.url}>
                    <input value={news.url} />
                    <button
                      onClick={() => {
                        pasteURL();
                        navigator.clipboard.writeText(window.location.href);
                      }}
                    >
                      URL 복사
                    </button>
                  </div>
                </Paper>
              </Fade>
            )}
          </Popper>
        </div>
      </div>
    </div>
  );
};

export default SingleNewsCard;
